export function handleDatabaseRequestError(vue, error, requestErrorHooks, preventGeneralSaveErrorNotifications) {
  const { $store, $i18n } = vue;
  const isRequestError = error && error.response && error.response.data;
  const inputErrors = getInputErrorsFromResponse(error, $store, $i18n);
  console.log(isRequestError, inputErrors, inputErrors.length, error);
  if (isRequestError) {
    const { data } = error.response;
    if (Array.isArray(data)) {
      // Handle Request error hooks (components)
      data.forEach(err => {
        const errCode = err.code || err.Code;
        const errMessage = err.message || err.Message;
        const hooks = requestErrorHooks && requestErrorHooks[errCode];
        if (Array.isArray(hooks) && hooks.length) {
          hooks.forEach(hook => hook(errCode, errMessage));
        }
      });

      // Handle Input errors
      if (Object.keys(inputErrors).length > 0) {
        $store.dispatch('notify/error', { message: $i18n.t('error.oneOrMoreInputs') });
      }
    } // Other request related errors are handled by axios interceptor
  } else if (!preventGeneralSaveErrorNotifications) {
    // Handle error not related to request
    $store.dispatch('notify/dataSaveError');
  }
  return inputErrors;
}

function getInputErrorsFromResponse(error, store, i18n) {
  const isRequestError = error && error.response && error.response.data;
  const { validationErrorInputPrefix } = store.getters;
  const errors = {};
  if (isRequestError) {
    const { data } = error.response;
    if (Array.isArray(data)) {
      data.forEach(err => {
        const errCode = err.code || err.Code;
        if (errCode && errCode.startsWith(validationErrorInputPrefix)) {
          const field = errCode.substring(validationErrorInputPrefix.length).replace(/\..*$/, '');
          errors[field] = [err.message || err.Message || i18n.t(errCode)];
        }
      });
    }
  }
  return errors;
}
